import { c as _c } from "react/compiler-runtime";
import type { RiskSignal } from '@onefootprint/request-types/dashboard';
import { CodeInline } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import capitalize from 'lodash/capitalize';
type ReasonCodeCardProps = {
  reason: RiskSignal;
  hasSubcategory: boolean;
  tabIndex?: number;
};
const ReasonCodeCard = t0 => {
  const $ = _c(29);
  const {
    reason,
    hasSubcategory,
    tabIndex: t1
  } = t0;
  const tabIndex = t1 === undefined ? 0 : t1;
  const t2 = reason.id;
  const t3 = !hasSubcategory;
  let t4;
  if ($[0] !== hasSubcategory || $[1] !== t3) {
    t4 = cx("relative flex-col list-none rounded decoration-none first:mt-2 last:mb-2", {
      "pl-3": t3,
      "pl-6": hasSubcategory
    });
    $[0] = hasSubcategory;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `${reason.reasonCode} ${reason.description}`;
  let t6;
  if ($[3] !== reason.reasonCode) {
    t6 = <CodeInline size="compact">{reason.reasonCode}</CodeInline>;
    $[3] = reason.reasonCode;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = reason.severity === "high";
  const t8 = reason.severity === "medium";
  const t9 = reason.severity === "low";
  let t10;
  if ($[5] !== t7 || $[6] !== t8 || $[7] !== t9) {
    t10 = cx("text-snippet-2 shrink-0", {
      "text-error": t7,
      "text-warning": t8,
      "text-success": t9
    });
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== reason.severity) {
    t11 = capitalize(reason.severity);
    $[9] = reason.severity;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t10 || $[12] !== t11) {
    t12 = <p className={t10}>{t11}</p>;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== reason.description) {
    t13 = <p className="text-body-2 text-tertiary">{reason.description}</p>;
    $[14] = reason.description;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t12 || $[17] !== t13) {
    t14 = <div className="flex relative flex-col py-2 pl-3 ml-2 before:absolute before:left-0 before:top-0 before:bottom-0 before:w-[1px] before:bg-gradient-to-b before:from-[var(--border-color-tertiary)] before:to-transparent">{t12}{t13}</div>;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14 || $[20] !== t6) {
    t15 = <div className="flex flex-col items-start max-w-full align-start">{t6}{t14}</div>;
    $[19] = t14;
    $[20] = t6;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== hasSubcategory || $[23] !== reason.id || $[24] !== t15 || $[25] !== t4 || $[26] !== t5 || $[27] !== tabIndex) {
    t16 = <li key={t2} className={t4} role="treeitem" tabIndex={tabIndex} aria-expanded={hasSubcategory} aria-label={t5}>{t15}</li>;
    $[22] = hasSubcategory;
    $[23] = reason.id;
    $[24] = t15;
    $[25] = t4;
    $[26] = t5;
    $[27] = tabIndex;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
};
export default ReasonCodeCard;